import React, {useState} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import InboxIcon from '@mui/icons-material/Inbox';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MailIcon from '@mui/icons-material/Mail';
import BusinessIcon from '@mui/icons-material/Business';
import { ReactComponent as Logo } from "./logo2.svg";

import './App.css';
import {
  Alert,
  alpha,
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  styled, SvgIcon,
  Toolbar,
  Typography
} from "@mui/material";
import theme from "./Theme";
import {ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MainPage from "./main/MainPage";

const StyledSearch = styled("div")(({theme}) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.primary.main, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({theme}) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({theme}) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

//search as JSX
const search = (
    <StyledSearch>
      <SearchIconWrapper>
        <SearchIcon/>
      </SearchIconWrapper>
      <StyledInputBase
          placeholder="Search…"
          inputProps={{"aria-label": "search"}}
      />
    </StyledSearch>
);

function App() {
  const searchString = window.location.search;
  const params = new URLSearchParams(searchString);
  const adminName = params.get('admin') || '';
  const [open, toggleState] = useState(false);

  const toggleDrawer = (open: boolean) => (event: any) => {
    if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    //changes the function state according to the value of open
    toggleState(open);
  };
  return (
      <ThemeProvider theme={theme}>
        <CssBaseline/>
        <AppBar position="relative">
          <Toolbar>
            <Logo/>
            <Typography variant="h6" sx={{flexGrow: 1, fontWeight: 700}} color="inherit" noWrap>

            </Typography>

            <Box
                component="div"
                sx={{
                  display: {
                    xs: "none",
                    sm: "block",
                  },
                }}
            >
              {search}
            </Box>

            <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer(true)}
                sx={{
                  mr: 2,
                  alignItems: "right",
                  display: {
                    xs: "block",
                  },
                }}
            >
              <MenuIcon/>
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer variant="temporary" anchor="right" open={open}>
          <div>
            <IconButton onClick={toggleDrawer(false)}>
              <ChevronRightIcon/>
            </IconButton>
          </div>
          <Divider/>
          <List>
            {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
                <ListItem button key={text}>
                  <ListItemIcon>
                    {index % 2 === 0 ? <InboxIcon/> : <MailIcon/>}
                  </ListItemIcon>
                  <ListItemText primary={text}/>
                </ListItem>
            ))}
          </List>
          <Divider/>
          <List>
            {["All mail", "Trash", "Spam"].map((text, index) => (
                <ListItem button key={text}>
                  <ListItemIcon>
                    {index % 2 === 0 ? <InboxIcon/> : <MailIcon/>}
                  </ListItemIcon>
                  <ListItemText primary={text}/>
                </ListItem>
            ))}
          </List>
        </Drawer>
        <Alert severity="warning" sx={{display: "flex", width: '100%', justifyContent: "center"}}>Under
          Construction</Alert>
        <MainPage adminName={adminName}/>
      </ThemeProvider>
  );
}

export default App;
